import { render, staticRenderFns } from "./PictureChoice.vue?vue&type=template&id=46775446&scoped=true&"
import script from "./PictureChoice.vue?vue&type=script&lang=js&"
export * from "./PictureChoice.vue?vue&type=script&lang=js&"
import style0 from "./PictureChoice.vue?vue&type=style&index=0&id=46775446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46775446",
  null
  
)

export default component.exports